import { render } from "./JobRequirement.vue?vue&type=template&id=394235e6&scoped=true"
import script from "./JobRequirement.vue?vue&type=script&lang=js"
export * from "./JobRequirement.vue?vue&type=script&lang=js"

import "./JobRequirement.vue?vue&type=style&index=0&id=394235e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394235e6"]])

export default __exports__